import React from 'react';
import SettingsContainer, { SettingsSettingType } from '../../../components/settings/SettingsContainer';

const ProjectSettings: React.FC = () => {
    const settings: SettingsSettingType[] = [
        {
            title: 'project.settings.job_method_title',
            explanationText: 'project.settings.job_method_explanation',
            fields: [
                {
                    type: 'tabs',
                    name: 'project_job_method',
                    buttonSize: 'large',
                    options: [
                        { value: 'individual_jobs', name: 'project.settings.individual_jobs_option' },
                        { value: 'longer_term', name: 'project.settings.longer_term_option' },
                    ]
                }
            ]
        },
        {
            title: 'project.settings.numbering_scheme_title',
            explanationText: 'project.settings.numbering_scheme_explanation',
            fields: [
                {
                    type: 'text',
                    label: 'settings.general.number_sequence_title',
                    name: 'project_numbering_scheme',
                    tooltipText: 'project.settings.numbering_scheme_tooltip',
                    placeholder: '',
                    group: 'field-row',
                    width: '30%',
                    shouldAutoFocus: false,
                },
                {
                    type: 'number',
                    label: 'settings.general.next_number_label',
                    name: 'project_current_number',
                    group: 'field-row',
                    width: '30%',
                }
            ]
        },

    ];

    return (
        <SettingsContainer settings={settings} environmentScope={true} />
    );
};

export default ProjectSettings;
